export const isWronglyFormattedEmail = emailAddress =>
  !/[^@\s]+@[^@\s]+\.[^@\s]+/.test(emailAddress)
